import { defineStore } from 'pinia'

type MagicLinkState = {
  isProcessing: boolean
}

export const useMagicLinkStore = defineStore('magic-link', {
  state: (): MagicLinkState => ({
    isProcessing: false,
  }),
  actions: {
    startProcessing() {
      this.isProcessing = true
    },
    stopProcessing() {
      this.isProcessing = false
    },
  },
})
